import React, { Component } from "react";

import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import CircularProgress from "@material-ui/core/CircularProgress";


import DashboardWrapper from "../containers/AdminWrapper";
import ContentWrapper from "../containers/ContentWrapper";

import reportsService from "../services/reportsService";

import ScheduleIcon from '@material-ui/icons/Schedule';
import CachedIcon from '@material-ui/icons/Cached';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CameraIcon from '@material-ui/icons/Camera';
import VideocamIcon from '@material-ui/icons/Videocam';
import PersonIcon from '@material-ui/icons/Person';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';

//actions
import * as dashboardActions from "../redux/actions/dashboardActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DateFormatter from "./utils/DateFormatter";

import CountUp from 'react-countup';

class MainDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedShoots: null,
      onGoingShootsTable: [],
      ongoingShoots: null,
      photoShots: null,
      scheduledShoots: null,
      shooters: null,
      videoShots: null,
      fetching: true,
      failed: false,
      fetched: false,
      onGoingShoot: [],
      scheduledShoot: [],
      completedShoot: [],
      activeStep: 0,
      activeColor: 'active-scheduled'
    };
  }

  componentDidMount() {
    this.getShoots();
    this.props.dashboardActions.fetchDashboardData();
  }

  getShoots = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let onGoing = reportsService.getOngoingShootReports();
      let scheduled = reportsService.getScheduledShootReports(); 
      let completed = reportsService.getCompletedShootReports();
      console.log('completerd',completed);
      let [onGoingShoot, scheduledShoot, completedShoot] = await Promise.all([onGoing, scheduled, completed]);
      console.log('data',onGoingShoot, scheduledShoot, completedShoot);
      this.setState({ onGoingShoot: onGoingShoot.data, scheduledShoot: scheduledShoot.data, completedShoot: completedShoot.data, fetching: false, fetched: true, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true, fetched: false });
    }
  };
  handleStep = step => () => {

    let activeColor = 'active-scheduled';
    switch (step) {
      case 0:
        activeColor = 'active-scheduled';
        break;
      case 1:
        activeColor = 'active-ongoing';
        break;
      case 2:
        activeColor = 'active-completed';
        break;
      default:
        activeColor = 'active-scheduled';
    }
    this.setState({activeStep: step, activeColor});
  };
  getStepIcon = (step, active) => {
    switch (step) {
      case 0:
        return <ScheduleIcon style={{color: (step == active && '#fff')}} fontSize="small" />;
      case 1:
        return <CachedIcon style={{color: (step == active && '#fff')}} fontSize="small" />;
      case 2:
        return <DoneAllIcon style={{color: (step == active && '#fff')}} fontSize="small" />;
      default:
        return 'Unknown step';
    }
  }
  getStepTableTitleContent = (step) => {
    switch (step) {
      case 0:
        return 'Scheduled Shoots';
      case 1:
        return 'Ongoing Shoots';
      case 2:
        return 'Completed Shoots';
      default:
        return 'Unknown step';
    }
  }
  getStepTableColor = (step) => {
    switch (step) {
      case 0:
        return 'var(--main-color)';
      case 1:
        return 'var(--warning-color)';
      case 2:
        return 'var(--info-color)';
      default:
        return 'Unknown step';
    }
  }
  getStepTableContent = (step) => {
    let { onGoingShoot, scheduledShoot, completedShoot } = this.state;
    switch (step) {
      case 0:
        return (
          scheduledShoot.length > 0 ?
          scheduledShoot.map(row => (
            <TableRow key={`${row.clinic}:${row.created_at}`}>
              <TableCell component="th" scope="row">
                {row.clinic}
              </TableCell>
              <TableCell>
                <DateFormatter date={row.date} />
              </TableCell>
              <TableCell>{row.address}</TableCell>
              <TableCell align="right">{row.progress.total.toFixed(0)}%</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>{`${row.shooter.UserAttributes.given_name} ${row.shooter.UserAttributes.family_name}`}</TableCell>
            </TableRow>
            ))
            :
            <TableRow >
              <TableCell colSpan={6}  align="center" style={{padding: 150}}>
                No Scheduled Shoots
              </TableCell>
            </TableRow>
        );
      case 1:
        return (
          onGoingShoot.length > 0 ?
          onGoingShoot.map(row => (
            <TableRow key={`${row.clinic}:${row.created_at}`}>
              <TableCell component="th" scope="row">
                {row.clinic}
              </TableCell>
              <TableCell>
                <DateFormatter date={row.date} />
              </TableCell>
              <TableCell>{row.address}</TableCell>
              <TableCell align="right">{row.progress.total.toFixed(0)}%</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>{`${row.shooter.UserAttributes.given_name} ${row.shooter.UserAttributes.family_name}`}</TableCell>
            </TableRow>
            ))
            :
            <TableRow >
              <TableCell colSpan={6}  align="center" style={{padding: 150}}>
                No Ongoing Shoots
              </TableCell>
            </TableRow>
        );
      case 2:
        return (
          completedShoot.length > 0 ?
          completedShoot.map(row => (
            <TableRow key={`${row.clinic}:${row.created_at}`}>
              <TableCell component="th" scope="row">
                {row.clinic}
              </TableCell>
              <TableCell>
                <DateFormatter date={row.date} />
              </TableCell>
              <TableCell>{row.address}</TableCell>
              <TableCell align="right">{row.progress.total.toFixed(0)}%</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>{`${row.shooter.UserAttributes.given_name} ${row.shooter.UserAttributes.family_name}`}</TableCell>
            </TableRow>
            ))
            :
            <TableRow >
              <TableCell colSpan={6}  align="center" style={{padding: 150}}>
                No Completed Shoots
              </TableCell>
            </TableRow>
        );
      default:
        return 'Unknown step';
    }
  }
  render() {
    let { completedShoots, ongoingShoots, photoShots, scheduledShoots, shooters, videoShots } = this.props.dashboard.data;
    let { onGoingShoot, activeStep, activeColor } = this.state;
    let steps =  ['Scheduled Shoots', 'Ongoing Shoots', 'Completed Shoots'];
    
    let { fetching, fetched } = this.props.dashboard;
    return (
      <DashboardWrapper {...this.props}>
        <ContentWrapper hasPadding>
          <div className="dashboard-grid" style={{marginTop: 30, marginBottom: 50}}>
            <Paper className="paper1" onClick={this.handleStep(0)} style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--main-color)', boxShadow: (activeStep == 0 && '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)')}}>
              <ScheduleIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ marginBottom: 5,color: '#fff' }}>Scheduled Shoot</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
              <Typography variant="h3" style={{ color: '#fff' }}><b><CountUp end={scheduledShoots} /></b></Typography>
              )}
            </Paper>
            <Paper className="paper2"  onClick={this.handleStep(1)}  style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--warning-color)', boxShadow: (activeStep == 1 && '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)')}}>
              <CachedIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ marginBottom: 5,color: '#fff' }}>Ongoing Shoot</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
                <Typography variant="h3" style={{ color: '#fff' }}><b><CountUp end={ongoingShoots} /></b></Typography>
              )}
              
            </Paper>
            <Paper className="paper3"  onClick={this.handleStep(2)} style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--info-color)', boxShadow: (activeStep == 2 && '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)')}}>
              <DoneAllIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ color: '#fff' }}>Completed Shoot</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
              <Typography variant="h3" style={{marginBottom: 5, color: '#fff'}}><b><CountUp end={completedShoots} /></b></Typography>
              )}
            </Paper>
            <Paper className="paper4" style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--secondary-color)'}} onClick={()=>this.props.history.push('/shots/photo')}>
              <CameraIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ color: '#fff' }}>Photo Shots</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
              <Typography variant="h3" style={{marginBottom: 5, color: '#fff'}}><b><CountUp end={photoShots} /></b></Typography>
              )}
            </Paper>
            <Paper className="paper5" style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--violet-color)'}} onClick={()=>this.prips.history.push('/shots/video')}>
              <VideocamIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ color: '#fff' }}>Video Shots</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
              <Typography variant="h3" style={{marginBottom: 5, color: '#fff'}}><b><CountUp end={videoShots} /></b></Typography>
              )}
            </Paper>
            <Paper className="paper6" style={{padding: 24, textAlign: 'center', backgroundColor: 'var(--dark-color)'}} onClick={()=>this.props.history.push('/accounts')}>
              <PersonIcon style={{color: '#fff'}} fontSize="large" />
              <Typography variant="subtitle1" style={{ color: '#fff' }}>Shooters</Typography>
              {fetching && !fetched ? (
                  <CircularProgress style={{color: '#fff'}}/>
              ) : (
              <Typography variant="h3" style={{marginBottom: 5, color: '#fff'}}><CountUp end={shooters} /><b></b></Typography>
              )}
            </Paper>
          </div>
          {/* <Typography variant="h4">SHOOTS</Typography>
          <Divider/>
          
          <Paper style={{ padding: 10, marginTop: 30, borderTop: '2px solid var(--warning-color)' }}>
            <h2 style={{ margin: "10px", color: 'var(--warning-color)' }}>Ongoing Shoots</h2>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell >Clinic Name</TableCell>
                  <TableCell >Shoot Date</TableCell>
                  <TableCell >Address</TableCell>
                  <TableCell align="right" >Progress</TableCell>
                  <TableCell >Type</TableCell>
                  <TableCell >Shooter</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {onGoingShoot.map(row => (
                <TableRow key={`${row.clinic}:${row.created_at}`}>
                  <TableCell component="th" scope="row">
                    {row.clinic}
                  </TableCell>
                  <TableCell>
                    <DateFormatter date={row.date} />
                  </TableCell>
                  <TableCell>{row.address}</TableCell>
                  <TableCell align="right">{row.progress.total.toFixed(0)}%</TableCell>
                  <TableCell>{row.type}</TableCell>
                  <TableCell>{`${row.shooter.UserAttributes.given_name} ${row.shooter.UserAttributes.family_name}`}</TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper> */}
    <div style={{width: '100%'}}>
      <Stepper nonLinear activeStep={activeStep} style={{backgroundColor: 'inherit'}}>
        {steps.map((label, index) => {
          const buttonProps = {};
          return (
            <Step key={label}>
              <StepButton
                className={`custom-step-icon ${activeStep == index && activeColor}`}
                onClick={this.handleStep(index)}
                {...buttonProps}
                icon={this.getStepIcon(index, activeStep)}
              >
                {label}
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
      <div>
        {/* <Typography style={{marginTop: 8, marginBottom: 8}}>{this.getStepContent(activeStep)}</Typography> */}
        <Paper style={{ padding: 10, marginTop: 30, borderTop: '2px solid', borderColor: (this.getStepTableColor(activeStep)) }}>
      <h2 style={{ margin: "10px", color: (this.getStepTableColor(activeStep)) }}>{this.getStepTableTitleContent(activeStep)}</h2>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell >Clinic Name</TableCell>
                  <TableCell >Shoot Date</TableCell>
                  <TableCell >Address</TableCell>
                  <TableCell align="right" >Progress</TableCell>
                  <TableCell >Type</TableCell>
                  <TableCell >Shooter</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.getStepTableContent(activeStep)}
              </TableBody>
            </Table>
            
          </Paper>
      </div>
    </div>
        </ContentWrapper>
      </DashboardWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard: state.dashboard
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainDashboard);
